import React from "react";

import Button, { ButtonProps } from "../../button/Button";
import { MarkRelevant } from "../../svg/svgImageList";

export default function MarkRelevantButton(props: ButtonProps) {
  const { disabled, tooltipKey: tooltip, onClick, textKey } = props;

  return (
    <Button
      id="mark-relevant"
      disabled={disabled}
      onClick={onClick}
      tooltipKey={tooltip}
      icon={{
        svg: MarkRelevant,
        textKey: textKey || "general.inspection.relevance.mark-relevant",
        textClass: "actions-header-button-label",
      }}
    />
  );
}
